// tslint:disable:max-line-length
import * as React from 'react';
import { createIcon } from '../createIcon';

function PlayFilled() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    "data-fill-rule": "fill",
    d: "M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-4.377 8.8l-4.016 3C6.004 12.3 5 11.8 5 11V5c0-.8.904-1.3 1.607-.8l4.016 3c.503.4.503 1.2 0 1.6z"
  }));
}

export var PlayFilledIcon = createIcon(PlayFilled); // tslint:enable:max-line-length